import { create } from 'zustand';
import type { GroupBearingOverride } from '../data/overridesRuntime';
import { fetchAndApplyOverrides } from '../data/refreshOverrides';

/**
 * groupBearingOverridesDraft — guarda directamente una corrección de
 * rotación de grupo (sección "Cablear grupos" de Modo Edición). Mismo
 * patrón que `osmGroupOverridesDraft.ts`: sin estado propio, tras cada
 * escritura se vuelve a pedir `GET /api/overrides` y se aplica sobre
 * `overridesRuntime.ts`.
 */
export type { GroupBearingOverride as GroupBearingOverrideDraft } from '../data/overridesRuntime';

interface DraftState {
  saving: boolean;
  stage: (d: GroupBearingOverride) => Promise<boolean>;
  remove: (cabinetId: number, groupId: number) => Promise<boolean>;
}

export const useGroupBearingOverridesDraft = create<DraftState>((set) => ({
  saving: false,
  stage: async (d) => {
    set({ saving: true });
    try {
      const res = await fetch(`/api/overrides/group_bearing/${d.cabinetId}-${d.groupId}`, {
        method: 'PUT',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(d),
      });
      if (!res.ok) return false;
      await fetchAndApplyOverrides();
      return true;
    } catch {
      return false;
    } finally {
      set({ saving: false });
    }
  },
  remove: async (cabinetId, groupId) => {
    set({ saving: true });
    try {
      const res = await fetch(`/api/overrides/group_bearing/${cabinetId}-${groupId}`, {
        method: 'DELETE',
        credentials: 'include',
      });
      if (!res.ok && res.status !== 404) return false;
      await fetchAndApplyOverrides();
      return true;
    } catch {
      return false;
    } finally {
      set({ saving: false });
    }
  },
}));
